<template>
  <block-template
    :data="data"
    title="YouTube"
    :possible-next="possibleNext"
    :is-last="isLast"
  >
    <div class="ytContent">
      <iframe
        :src="iframeSrc"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      >
      </iframe>
    </div>
  </block-template>
</template>

<script>
import BlockTemplate from "./Template";
export default {
  name: "BlockYoutube",
  components: { BlockTemplate },
  props: {
    data: {
      type: Object,
      required: true,
      content: {
        type: String,
        required: true
      },
      parent_type: {
        type: String,
        required: true
      },
      parent_id: {
        type: Number,
        required: true
      }
    },
    possibleNext: {
      type: Object,
      required: true
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iframeSrc() {
      return "https://www.youtube.com/embed/" + this.data.content;
    }
  },
};
</script>
<style lang="scss">
.ytContent {
  width: 100%;
  height: 0;
  padding-top: 66.6%;
  position: relative;

  iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }
}
</style>
